<template>
  <b-row>
    <b-col cols="12">
      <b-row style="margin-top:-1%" class="mb-1">
          <b-col>
            <div 
                :style="{
                  width: '8px',
                  height: '8px',
                  backgroundColor: swtichColorWhenDarkMode('yellow','#e6e65c'),
                  borderRadius: '50%',
                  display: 'inline-block'
                }">
              </div>
              <span style="font-size: 0.75em;; margin-left:5px"> เหลือเวลาน้อยกว่า 50% จะตก SLA</span>
       
            <div 
                class="ml-1"
                :style="{
                  width: '8px',
                  height: '8px',
                  backgroundColor: 'orange',
                  borderRadius: '50%',
                  display: 'inline-block'
                }">
              </div> 
              <span style="font-size: 0.75em; margin-left:5px">เหลือเวลาน้อยกว่า 25% จะตก SLA</span>
       
            <div 
                class="ml-1"
                :style="{
                  width: '8px',
                  height: '8px',
                  backgroundColor: 'red',
                  borderRadius: '50%',
                  display: 'inline-block'
                }">
              </div> 
              <span style="font-size: 0.75em;; margin-left:5px">ตก SLA</span>
          </b-col>
        </b-row>

      <b-card>

        <b-row>
          <b-col md="6" class="my-1">
            <h2>Inprogress (ใบงานทั้งหมด {{ showNumberItem }} ใบงาน)</h2>
          </b-col>
          <b-col md="6" class="my-1">
            <b-form
              v-on:submit.prevent
              inline
              class="d-flex justify-content-md-end align-items-center"
            >
              <b-input-group class="input-group-merge flex-grow-1 mb-2 mb-md-0">
                <b-form-input
                  id="basic-password1"
                  type="text"
                  placeholder="Search..."
                  v-model="filter"
                />
                <b-input-group-append is-text>
                  <feather-icon icon="SearchIcon" class="cursor-pointer" />
                </b-input-group-append>
              </b-input-group>
              <div class="d-flex flex-wrap">
                <b-button
                  v-if="exportPermission == 'view'"
                  variant="outline-secondary"
                  class="ml-1 shadow"
                >
                  <export-excel
                    :data="itemsExport"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="All Inprogress Tickets.xls"
                  >
                    Export <feather-icon icon="FileTextIcon" size="14" /> 
                  </export-excel>
                </b-button>

                <b-button
                  v-if="
                    ticketPermission == 'create' || ticketPermission == 'edit'
                  "
                  variant="primary"
                  class="ml-1 shadow"
                  @click="$router.push('/ticket/create')"
                >
                  เปิดใบงาน <feather-icon icon="PlusCircleIcon" size="14" />
                </b-button>
              </div>
            </b-form>
          </b-col>

          <b-col cols="12">
            <b-table
              style="font-size: 12px"
              class="shadow text-center"
              small
              striped
              bordered
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              selectable
              select-mode="single"
              @row-selected="onSelectTickett"
              :busy="isLoading"
            >
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong> Loading...</strong>
                </div>
              </template>

              <template #cell(selected)="{ rowSelected }"></template>
              <template #cell(openTicketDate)="row">
                {{ showDate(row.item.openTicketDate, "original") }}
              </template>
              <template #cell(slaCountTime)="row">  
                <div v-if="row.item.slaCountTime > 0 && row.item.slaCountTimeLastUpdate && row.item.isUseSlaSetting">
                {{ calSlaTime(row.item.catTime, row.item.slaCountTime).display }}                 
                <div 
                v-if="row.item.isShowSlaAlertColor"
                :style="{
                  width: '8px',
                  height: '8px',
                  backgroundColor: getSLAColor(row.item.slaCountTime, row.item.catTime*60),
                  borderRadius: '50%',
                  display: 'inline-block'
                }">
              </div>
              </div>
                
              </template>
            </b-table>
          </b-col>
          <b-col cols="6" md="2">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>

          <b-col cols="6"  md="10" class="d-flex justify-content-end">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              variant="secondary"
              class="my-0"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import moment from "moment";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BForm,
  BSpinner,
} from "bootstrap-vue";

import Field from "./field";
import FieldExport from "./field/export";
import TicketService from "@/services/ticket";
import commaNumber from "comma-number";
import { DISPLAY_SLA_TIME,  CONVET_MINUTES_TO_HOURS, FORMAT_TIME  } from "@/utils/";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCard,
    BForm,
    BSpinner,
  },
  data() {
    return {
      perPage: 1000,
      pageOptions: [1000, 2000, 5000],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],

      fields: Field,
      items: [],
      isLoading: false,
      json_fields: {},
      itemsExport: [],
      slaTimeHolder:{}
    };
  },
  computed: {
    isDarkMode(){
      const { skin } = useAppConfig()
      return skin.value == "dark" ? true : false
    },
    ticketPermission() {
      const permission = this.$store.getters["user/getPermissionPage"]("TK001");
      if(permission=="disable"){
        localStorage.removeItem("userData")
        window.location.href="/not-authorized"
      }
      return permission
    },
    exportPermission() {
      return this.$store.getters["user/getPermissionPage"]("TK002");
    },
    showNumberItem() {
      return commaNumber(this.items.length);
    },
  },

  methods: {
    async getTicketLists() {
      try {
        this.isLoading = true;
        const result = await TicketService.GetTicketList({});
        this.items = result.data.data;
        this.totalRows = this.items.length;   
        this.isLoading = false;
      } catch (error) {
        alert("Load data error.");
      }
    },

    onSelectTickett(item) {
      this.$router.push(`/ticket/edit/${item[0].ticketId}`);
    },

    showSlaTime(totalMinutes){      
      return DISPLAY_SLA_TIME(totalMinutes)
    },

    calSlaTime(catTime, currentSlaTime){
      const totalTime = CONVET_MINUTES_TO_HOURS(currentSlaTime) 
      const sum = (catTime*60) - currentSlaTime 
      const sumHourFormat = CONVET_MINUTES_TO_HOURS(sum)
      
      const result = catTime - totalTime
      console.log("result=>", catTime, totalTime, result)
      return {
        result: sumHourFormat,
        display: sumHourFormat > 0 ? FORMAT_TIME(Math.abs(sumHourFormat)) : 0
      }
     
    },
    

    showDate(date, type = "") {
      if (type == "date") {
        return moment(date).format("DD-MM-yyyy");
      }

      if (type == "original") {
        return moment(date).subtract(7, "h").format("DD-MM-yyyy HH:mm:ss");
      }

      if (type == "subtract") {
        return moment(date).subtract(7, "h");
      }

      return moment(date).format("DD-MM-yyyy HH:mm:ss");
    },
    buildFieldExcel() {
      let obj = {};
      FieldExport.forEach((f) => {
        if (f.key == "openTicketDate") {
          obj[f.label] = {
            field: f.key,
            callback: (value) => {
              return this.showDate(value, "original");
            },
          };        
        } else {
          obj[f.label] = f.key;
        }
      });

      this.json_fields = obj;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    buidTicketListForExport(){
      this.itemsExport = this.items.map((ticket)=>{
        const payload =  {
          ...ticket,         
          slaCountTime: ticket.slaCountTime && this.calSlaTime(ticket.catTime, ticket.slaCountTime).display
        }

        if(ticket.slaCountTime && this.calSlaTime(ticket.catTime, ticket.slaCountTime).result <= 0){
          payload.slaCountTime = "-" + payload.slaCountTime
        }

        return payload
      })
    },
    getSLAColor(usedTime, totalTime) {
      const usedPercentage = (usedTime / totalTime) * 100;
      const remainingPercentage = 100 - usedPercentage;

      if (remainingPercentage > 50) {
          return null
      } else if (remainingPercentage >= 25) {
          return this.swtichColorWhenDarkMode('yellow','#e6e65c'); // SLA เหลือ 30-50%
      } else if (remainingPercentage > 0) {
          return "orange"; // SLA เหลือต่ำกว่า 30%
      } else {
          return "red"; // ตก SLA
      }
    },
    swtichColorWhenDarkMode(colorName, color){
      if(this.isDarkMode){
        if(colorName=="yellow"){
          return "#f4f469"
        }
        return color
      }
      return color
    }
  },


  async mounted() {
    await this.getTicketLists();
    this.buidTicketListForExport()
    this.buildFieldExcel();
  },
};
</script>

<style scoped>
.table-hover tbody tr:hover {
  background-color: aqua !important;
}
</style>
